import { useState, useEffect } from "react";
import UniversalInput from "@/components/FormsElements/UniversalInput";
import MainButton from "@/components/Button/MainButton";
import { Link } from "@/i18n/navigation";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import config from "../../../../config.mjs";


const LoginPage = () => {
  const t = useTranslations('login');
  const [isLoading, setIsLoading] = useState(false);
  const [buttonDisabled, setIsButtonDisabled] = useState(true);
  const [authorEmail, setAuthorEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(authorEmail.trim());
  const isButtonDisabled = !isValidEmail || authorEmail.trim() === "" || password.trim() === "";

  const [textError, setTextError] = useState(null);

  const router = useRouter();
  const { apiBaseUrl } = config;

  useEffect(() => {
 
    // console.log("sessionStorage.getItem('sessionToken')", sessionStorage.getItem('sessionToken'));
    
    if (sessionStorage.getItem('sessionToken')) {
      
      router.push('/my-orders');
    }
  }, [router])

  const setUserTokenCookie = (token) => {
    const date = new Date();
    date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();

    document.cookie = `userToken=${token}; ${expires}; path=/; SameSite=Lax; Secure`;
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      setIsButtonDisabled(true);
      const response = await fetch(apiBaseUrl + '/user/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: authorEmail, password: password }),
      });
      // console.log(response.status);

      if (response.status === 200) {

        const data = await response.json();

        if (rememberMe) {
          setUserTokenCookie(data.token);
        }
        sessionStorage.setItem('sessionToken', data.token);
        setTextError(null);
        router.push('/my-orders');
        // Optionally show a success message to the user

      } else if (response.status === 401) {
        const data = await response.json();
        setTextError(data.message, 'Validation error or email not found.');

      }
    } catch (error) {


      console.error('Network error:', error);
      // Handle network or server errors
    } finally {
      setIsLoading(false);
      setIsButtonDisabled(false);
    }
  };



  return (
    <div className="w-full  ">
      <h2 className="text-center text-[32px] md:text-[44px] font-bold mb-6">{t('title')}</h2>
      <div className="pb-9">
        <UniversalInput
          type="email"
          placeholder={t('emailPlaceholder')}
          label={t('emailAddress')}
          value={authorEmail}
          onChange={setAuthorEmail}
          extraLabel={true}
          border={true}
          setIsButtonDisabled={setIsButtonDisabled}
        />

        <UniversalInput
          type="password"
          placeholder={t('passwordPlaceholder')}
          label={t('passwordLabel')}
          value={password}
          onChange={setPassword}
          extraLabel={true}
          border={true}
          setIsButtonDisabled={setIsButtonDisabled}
        />
        {
          textError && (
            <p className="text-red-500 text-sm mb-6 -mt-8">{textError}</p>
          )
        }
        <div className="flex md:items-center justify-between -mt-4 md:mt-0 mb-6 flex-col md:flex-row">
          <label className="flex items-center cursor-pointer f">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              className="hidden peer"
            />
            <div className="self-center mr-2 w-[18px] h-[18px] border border-gray-300 rounded flex items-center justify-center peer-checked:bg-gray-900">
              {rememberMe && (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            {t('rememberMe')}
          </label>

          <Link href="/reset-password" className="mt-3 md:-mt-6 self-center md:self-start text-gray-300/80 text-sm underline hover:text-gray-700 transition">
            {t('forgotPassword')}
          </Link>

        </div>
        <div className="mt-10 md:mt-0">

          <MainButton
            text={t('loginButton')}
            disabled={isButtonDisabled}
            fontSize="20px"
            onClick={handleLogin}
            isLoading={isLoading}
            buttonDisabled={buttonDisabled}
          />

        </div>

      </div>

    </div>
  );
};

export default LoginPage;
